/**
 * Hangar administration ↔ workspace (SPEC decision 22, plan P23), for platform operators only: two links, because each
 * view starts at a page (Clients, the overview), styled as one segmented control. On the tablet rail it is two icons.
 */
import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/utils';
import { Icon } from '@/components/Icon';
import type { ShellView } from './nav';

const VIEWS: { view: ShellView; label: string; short: string; icon: string; to: '/clients' | '/' }[] = [
  { view: 'admin', label: 'Hangar administration', short: 'Admin', icon: 'admin_panel_settings', to: '/clients' },
  { view: 'workspace', label: 'Workspace', short: 'Workspace', icon: 'space_dashboard', to: '/' },
];

export function ViewSwitch({ view, rail }: { view: ShellView; rail: boolean }) {
  return (
    <div role="group" aria-label="View" className={cn('rounded-lg border bg-secondary p-1', rail ? 'flex flex-col gap-1' : 'grid grid-cols-2 gap-1')}>
      {VIEWS.map((v) => {
        const on = v.view === view;
        return (
          <Link
            key={v.view}
            to={v.to}
            data-testid={`view-${v.view}`}
            aria-current={on ? 'page' : undefined}
            aria-label={v.label}
            title={rail ? v.label : undefined}
            className={cn(
              'flex items-center justify-center gap-1.5 rounded-md text-xs font-semibold transition-colors duration-150',
              rail ? 'size-11' : 'h-9 px-2',
              on ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground',
            )}
          >
            <Icon name={v.icon} size={rail ? 20 : 16} />
            {rail ? null : <span className="truncate">{v.short}</span>}
          </Link>
        );
      })}
    </div>
  );
}
